import { OldWidgetSettingsBuilder } from './old-widget-settings.builder';
var OldWidgetBuilder = /** @class */ (function () {
    function OldWidgetBuilder() {
        this.widget = {
            id: '5fcf384e-170c-4812-857e-6c997ad0cbda',
            name: 'Widget1',
            lastUpdateDate: Date.now(),
            creationDate: Date.now(),
            settings: new OldWidgetSettingsBuilder().build()
        };
    }
    OldWidgetBuilder.prototype.withId = function (id) {
        this.widget.id = id;
        return this;
    };
    OldWidgetBuilder.prototype.withName = function (name) {
        this.widget.name = name;
        return this;
    };
    OldWidgetBuilder.prototype.withSettings = function (settings) {
        this.widget.settings = settings;
        return this;
    };
    OldWidgetBuilder.prototype.withCreationDate = function (creationDate) {
        this.widget.creationDate = creationDate;
        return this;
    };
    OldWidgetBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.widget.lastUpdateDate = lastUpdateDate;
        return this;
    };
    OldWidgetBuilder.prototype.build = function () {
        return this.widget;
    };
    return OldWidgetBuilder;
}());
export { OldWidgetBuilder };
//# sourceMappingURL=old-widget.builder.js.map